<template>
  <div>
    <apexchart
      v-if="!noData"
      :height="height"
      type="line"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div v-else style="text-align: center">
      <div class="w-100">
        <span style="text-align: center">{{ $t(`texts.data.no-products-sold`) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "ProductsSoldChart",
  data: () => ({
    noData: false,
    series: [],
    chartOptions: {
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#FF4560",
        "#775DD0",
        "#3F51B5",
        "#546E7A",
        "#D4526E",
        "#8D5B4C",
        "#F86624",
        "#D7263D",
        "#1B998B",
        "#2E294E",
        "#F46036",
        "#E2C044",
      ],
      chart: {
        animations: {
          enabled: false,
        },
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.5,
        },
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [],
          },
        },
      },
      dataLabels: {
        enabled: true,
      },
      title: {
        text: "Sold products",
        align: "left",
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      markers: {
        size: 10,
      },
      xaxis: {
        title: {
          text: "Round",
        },
      },
      yaxis: {
        title: {
          text: "Sold products number",
        },
        labels: {
          offsetX: -3,
          formatter: function (val) {
            let floor = Math.floor(val);
            return floor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          },
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
      stroke: {
        show: true,
        curve: "straight",
        width: 3,
        dashArray: 0,
      },
      tooltip: {
        custom: function ({ seriesIndex, dataPointIndex, w }) {
          var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

          return (
            '<ul style="text-align: left">' +
            "<li><b>Round </b>: " +
            data.x +
            "</li>" +
            "<li><b>Profit</b>: " +
            data.profit +
            "</li>" +
            "<li><b>Total quantity</b>: " +
            data.y +
            "</li>" +
            (data.selectedTeam
              ? "<li><b>Product name</b>: " + data.productName + "</li>"
              : "") +
            "</ul>"
          );
        },
      },
    },
  }),
  props: {
    selectedTeam: Number,
    height: Number,
  },
  watch: {
    selectedTeam() {
      this.reset();
      if (this.selectedTeam != null) {
        this.createDataSetsProducts();
      } else {
        this.createDataSetsTeams();
      }
      this.setTitle();
    },
    gameProductsSales() {
      this.reset();
      if (this.selectedTeam != null) {
        this.createDataSetsProducts();
      } else {
        this.createDataSetsTeams();
      }
    },
  },
  created() {
    this.createDataSetsTeams(); //napoprvé jsou to vždy teamy, protože se konfigurace resetuje
    this.setTitle();
  },
  computed: {
    ...mapGetters([
      "gameProductsSales",
      "gameAllTeams",
      "activeGame",
      "ownerCurrentGame",
    ]),
    turn() {
      return this.activeGame.turn;
    },
    generateAllNumbers() {
      let arr = [];
      if (this.isArchived()) {
        for (let i = 1; i <= this.turn; i++) {
          arr.push(i);
        }
      } else {
        for (let i = 1; i < this.turn; i++) {
          arr.push(i);
        }
      }
      return arr;
    },
  },
  methods: {
    reset: function () {
      this.series = [];
      this.chartOptions.labels = [];
    },
    createDataSetsProducts: function () {
      let storeData = [...this.gameProductsSales];

      if (!storeData || !storeData.length > 0) {
        return false;
      }

      let oneTeam = storeData.find((d) => d.id === this.selectedTeam);
      const groupedProducts = _.groupBy(oneTeam.results, (item) => item.productName);
      const allProductsData = [];
      _.forOwn(groupedProducts, (productRows) => {
        if (productRows[0]) {
          allProductsData.push({
            productName: productRows[0].productName,
            results: productRows,
          });
        }
      });
      allProductsData.forEach((oneProduct) => {
        this.series.push({
          name: oneProduct.productName,
          data: this.createChartDataProducts(oneProduct.results),
        });
      });
    },
    createDataSetsTeams: function () {
      let storeData = [...this.gameProductsSales];

      if (!storeData || !storeData.length > 0) {
        this.noData = true;
        return false;
      }

      storeData.forEach((oneTeam) => {
        this.series.push({
          name: oneTeam.name,
          data: this.createChartDataTeams(oneTeam.results),
        });
      });
    },
    createChartDataProducts: function (results) {
      let data = [];
      this.generateAllNumbers.forEach((round) => {
        let productName = results[0].productName;
        if (results.some((d) => d.turn === round)) {
          let oneRoundResult = results.find((r) => r.turn === round);
          let quantity = oneRoundResult.count;
          let profit = oneRoundResult.profit;
          data.push({
            x: round,
            y: quantity,
            profit: profit,
            productName: productName,
            selectedTeam: this.selectedTeam,
          });
          /*
          Tady jsou původní grafy
          let profit = oneRoundResult.profit;
          data.push({
            x: round,
            y: profit,
            quantity: quantity,
            productName: productName,
            selectedTeam: this.selectedTeam
          });*/
        } else {
          data.push({
            x: round,
            y: 0,
            quantity: 0,
            profit: 0,
            productName: productName,
            selectedTeam: this.selectedTeam,
          });
        }
      });
      return data;
    },
    createChartDataTeams: function (results) {
      let data = [];
      const groupedTurnes = _.groupBy(results, (item) => item.turn);
      const allTurnsData = [];
      _.forOwn(groupedTurnes, (turnRows) => {
        if (turnRows[0]) {
          allTurnsData.push({
            turn: turnRows[0].turn,
            turnResults: turnRows,
          });
        }
      });
      this.generateAllNumbers.forEach((round) => {
        if (allTurnsData.some((d) => d.turn === round)) {
          let quantity = 0;
          let totalProfit = 0;
          allTurnsData
            .find((d) => d.turn === round)
            .turnResults.forEach((r) => {
              quantity += r.count;
              totalProfit += r.profit;
            });
          data.push({ x: round, y: totalProfit, quantity: quantity });
        } else {
          data.push({ x: round, y: 0, quantity: 0 });
        }
      });
      return data;
    },
    setTitle() {
      this.chartOptions = {
        ...this.chartOptions,
        title: {
          text: this.selectedTeam
            ? `Sold products of team ${
                this.gameAllTeams.find((t) => t.id === this.selectedTeam).name
              }`
            : "Sold products",
        },
      };
    },
    isArchived() {
      return this.ownerCurrentGame.endedTime != null;
    },
  },
};
</script>
